import { ReactNode } from 'react';
import { createLayoutManager, BasicLayout } from 'components';

import { PageLayoutType } from '../types';
import Header from '../Header';

import SideLayout from 'components/v2/layout/SideLayout';

export default createLayoutManager(
  (contentKey: string | number, type: PageLayoutType, children: ReactNode, systemMessage?: string) =>
    ({
      basic: <BasicLayout>{children}</BasicLayout>,
      app: <></>,
      side: <SideLayout>{children}</SideLayout>,
    })[type]
);
